export const DEFAULT_PAGE_TITLE = 'Luckyelfcasino';
